import React, { Fragment } from 'react';
import Header from '../../components/header/Header';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import ContactSection from '../../components/ContactSection';

const ContactPage = () => {
    return (
        <Fragment>
            <Header hclass={'header--styleFour'}/>
            <main className="main">
                <ContactSection />
            </main>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};

export default ContactPage;
